module.exports = __webpack_public_path__ + "img/69.d705fa05.jpg";